import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { IPage } from '../types/generated'

/**
 * Fetch a single Page from Contenful
 *
 * @param {string} slug The slug of this page
 */
export const fetchPage = async (slug: string): Promise<IPage | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'page',
      'fields.slug': slug,
      include: 5,
    }),
  ) as IPage | undefined
}

/**
 * Fetch all Pages from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchPages = async (
  query?: Record<string, unknown>,
): Promise<IPage[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      ...query,
      content_type: 'page',
    }),
  ) as IPage[]
}
